import React from 'react'
import cx from 'classnames'
import values from 'lodash/values'
import PropTypes from 'prop-types'
import { Icon, l } from '@manychat/manyui'

import FlowTextViewer from 'common/builder/components/misc/FlowTextViewer'
import { NextStepTypeColors, NextStepType } from 'common/builder/models/Source/constants'
import { isNextStepTypeUrl } from 'common/builder/utils/isNextStepTypeUrl'
import { Col, Row } from 'components/Grid'

import cm from './NextStepPane.module.css'

export default class NextStepPane extends React.Component {
  static propTypes = {
    onOpen: PropTypes.func,
    onReset: PropTypes.func,
    onChange: PropTypes.func,
    onCaptionClick: PropTypes.func,
    color: PropTypes.oneOf(values(NextStepTypeColors)),
    icon: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
    caption: PropTypes.string,
    readonly: PropTypes.bool,
    clickable: PropTypes.bool,
    theme: PropTypes.object,
    disableReset: PropTypes.bool,
  }

  handleReset = (e) => {
    const { onReset, readonly } = this.props

    e.stopPropagation()

    if (readonly) {
      return
    }
    onReset()
  }

  handleClick = () => {
    if (!this.props.clickable) {
      return
    }
    this.props.onOpen()
  }

  handleCaptionClick = () => {
    if (this.props.clickable) {
      return
    }

    this.props.onCaptionClick()
  }

  renderViewer = () => {
    const { clickable, viewer, caption, type } = this.props
    return viewer ? (
      viewer
    ) : (
      <FlowTextViewer
        className={cx(cm.caption, 'text-ellipsis p-relative', {
          'text-secondary': !clickable,
          [cm.url]: type === isNextStepTypeUrl(type),
          'd-none': type === NextStepType.SHARE,
        })}
        value={l.getString(caption)}
      />
    )
  }

  render() {
    const { title, color, icon, clickable, type, theme = {}, caption } = this.props
    const { readonly, disableReset } = this.props

    return (
      <Row
        middle
        nowrap
        className={cx(cm.wrap, cm[type], this.props.className, {
          [cm.readonly]: readonly,
        })}
      >
        <Col
          onClick={this.handleClick}
          className={cx(cm.body, { [cm.clickable]: clickable })}
          data-test-id="next-step-pane"
        >
          <Row middle className={cx(cm.innerRow, cm[type])}>
            {React.createElement(Icon[icon], {
              color: color,
              size: 32,
              className: 'm-l m-r',
            })}
            <Col>
              <div className={cx('text-subheading', cm.btnType)}>{title}</div>
              <div onClick={this.handleCaptionClick} className={cx(theme.viewerWrapper)}>
                <div title={caption}>{this.renderViewer()}</div>
              </div>
            </Col>
          </Row>
        </Col>

        {!disableReset && !readonly && (
          <div
            tabIndex="0"
            onClick={this.handleReset}
            className={cx(
              cm.innerBtn,
              cm[type],
              'd-flex jusyfy-center-align-center p-x-sm pointer',
            )}
          >
            {/* extra div to prevent an overflow bug in safari */}
            <div className="d-flex justify-center align-center">
              <Icon.Close size={24} className={cx(cm.deleteIcon, 'pointer')} />
            </div>
          </div>
        )}
      </Row>
    )
  }
}
